import { post } from '../utils/fetch';
import { apiUserSurveyPath } from 'routing/routes';
import UserSurvey from 'models/UserSurvey';

export const createUserSurvey = (userSurvey: UserSurvey) =>
  post(apiUserSurveyPath, userSurvey);
